import {
  SnippetElement,
  defineElement,
  on,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/pb-common-price/pb-common-price.ts
var PbCommonPrice = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  toggleQuantitySelect() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  open() {
    return __async(this, null, function* () {
      this.popover.open();
      this.isOpen = true;
      this.chevron.classList.remove("rotate-180");
    });
  }
  close() {
    return __async(this, null, function* () {
      this.popover.close();
      this.isOpen = false;
      this.chevron.classList.add("rotate-180");
    });
  }
  selectQuantity(elm) {
    return __async(this, null, function* () {
      if (elm.dataset.value == "custom") {
        yield this.popover.close();
        this.quantitySelect.classList.add("!hidden");
        this.quantitySelectInput.classList.remove("!hidden");
        this.quantityInputs[0].focus();
        return;
      }
      this.quantitySelectDisplay.textContent = elm.textContent;
      for (const input of this.quantityInputs) {
        input.textContent = elm.dataset.value;
        input.value = elm.dataset.value;
      }
      this.close();
    });
  }
};
__decorateClass([
  query("[data-quantity-popover]")
], PbCommonPrice.prototype, "popover", 2);
__decorateClass([
  query("[data-quantity-chevron]")
], PbCommonPrice.prototype, "chevron", 2);
__decorateClass([
  queryAll("[data-quantity]")
], PbCommonPrice.prototype, "quantityInputs", 2);
__decorateClass([
  query("[data-quantity-select-display]")
], PbCommonPrice.prototype, "quantitySelectDisplay", 2);
__decorateClass([
  query("[data-quantity-select-input]")
], PbCommonPrice.prototype, "quantitySelectInput", 2);
__decorateClass([
  query("[data-quantity-select]")
], PbCommonPrice.prototype, "quantitySelect", 2);
__decorateClass([
  on("click", "[data-quantity-select]")
], PbCommonPrice.prototype, "toggleQuantitySelect", 1);
__decorateClass([
  on("click", "[data-quantity-select-item]")
], PbCommonPrice.prototype, "selectQuantity", 1);
PbCommonPrice = __decorateClass([
  defineElement("pb-common-price")
], PbCommonPrice);
export {
  PbCommonPrice
};
